import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center mb-l" }
const _hoisted_2 = { class: "flex flex-col justify-between md:flex-row" }
const _hoisted_3 = { class: "flex items-center w-full space-x-s" }
const _hoisted_4 = { class: "mt-s md:mt-0 flex items-center justify-stretch space-x-s" }
const _hoisted_5 = { class: "flex space-x-s items-center justify-start" }
const _hoisted_6 = { class: "my-s mt-xs w-full" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "flex items-center justify-start py-xs"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "line-clamp-1" }, "Leer", -1)
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "flex-col !justify-start items-center w-full" }
const _hoisted_13 = { class: "line-clamp-1" }
const _hoisted_14 = { class: "text-xs text-gray-600 line-clamp-1" }
const _hoisted_15 = { class: "text-xs text-gray-600 line-clamp-1" }
const _hoisted_16 = { class: "px-xs" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-600 text-center" }, "Kühlschrank", -1)
const _hoisted_18 = { class: "px-xs" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-600 text-center" }, "Tresor", -1)
const _hoisted_20 = { class: "px-xs" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-600 w-tag text-center" }, " Status ", -1)

import { computed, ref } from "vue";

import EmptyContainer from "@/components/EmptyContainer.vue";
import { useOrdersStore } from "@/store/ordersStore";
import { MedicationOrderStatus } from "@/interfaces/enum/medicationOrderStatus";
import { BoxWithOrders, Message } from "@/interfaces/message";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import UButton from "@/components/UButton.vue";
import RoundedCard from "@/components/RoundedCard.vue";
import ChangeTag from "@/components/ChangeTag.vue";
import SmallTag from "@/components/SmallTag.vue";
import ToolTip from "@/components/ToolTip.vue";
import ProgressDot from "@/components/ProgressDot.vue";
import CircularProgress from "@/components/CircularProgress.vue";
import { usePublicStore } from "@/store/publicStore";
import { patientString } from "@/helpers/patienthelper";
import IconButton from "@/components/IconButton.vue";
import ProfileCircle from "@/components/ProfileCircle.vue";
import { isBoxDue, isBoxOverdue } from "@/helpers/orderhelper";
import OrderCalendar from "../components/OrderCalendar.vue";
import OrdersScanner from "../components/OrdersScanner.vue";
import { formatDate, localeDateStringFromDate } from "@/helpers/datehelper";
import { useRoute, useRouter } from "vue-router";
import { watch } from "vue";
import { format } from "path";
import { onMounted } from "vue";

type GroupedMessages = { [key: number]: BoxWithOrders[] };


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersDeliveryView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const cpgWithId = usePublicStore().careProviderGroupWithId;

const scannerOn = ref<boolean>(false);
const showCalendar = ref<boolean>(false);
const orderStore = useOrdersStore();
const folder = ref<number>(0);
const selectedDate = ref<Date | undefined>(new Date());

const organizedBoxes = computed(() =>
  orderStore.organizedBoxes.filter(
    (box) =>
      !filterDue.value ||
      isBoxDue(box, selectedDate.value) ||
      (isBoxOverdue(box, selectedDate.value) && box.folder < 2 && isToday.value)
  )
);

const isToday = computed(
  () =>
    selectedDate.value &&
    formatDate(selectedDate.value) == formatDate(new Date())
);

const filterDue = computed(() => selectedDate.value != null);

watch([folder, selectedDate], () => {
  router.replace({
    query: {
      selectedDate: selectedDate.value
        ? formatDate(selectedDate.value)
        : undefined,
      folder: folder.value,
    },
  });
});

onMounted(() => {
  selectedDate.value = route.query.selectedDate
    ? new Date(route.query.selectedDate as string)
    : new Date();
  folder.value = parseInt((route.query.folder as string) ?? "0") ?? 0;
});

function selectDate(date: Date) {
  selectedDate.value = date;
  showCalendar.value = false;
}

const groupedBoxesBySenderGroupId = computed<GroupedMessages>(() => {
  let groupedBoxes = organizedBoxes.value
    .filter((box) => box.folder == folder.value)
    .reduce((groups: GroupedMessages, message: BoxWithOrders) => {
      const groupId = message.conversation.sender_care_provider_group_id;
      if (!groups[groupId]) {
        groups[groupId] = [];
      }
      groups[groupId].push(message);
      return groups;
    }, {});
  return groupedBoxes;
});

function getFolders() {
  const folders = ["Ausstehend", "In Auslieferung", "Ausgeliefert"];
  const folderData: Array<{
    name: string;
    id: number;
    amount: number;
    color: "red" | "green";
  }> = [];
  for (const i of folders.keys()) {
    folderData.push({
      name: folders[i],
      id: i,
      amount: organizedBoxes.value.filter((box) => box.folder == i).length,
      color:
        organizedBoxes.value.filter(
          (box) => box.folder == i && isBoxOverdue(box)
        ).length > 0
          ? "red"
          : "green",
    });
  }
  return folderData;
}

function orderProgress(message?: Message) {
  return (
    MedicationOrderStatus.find(
      (s) => s.id == message?.medication_order?.status ?? 0
    )?.progress ?? 0
  );
}

function open(box: Message) {
  router.push(`/conversations/${box.conversation.id}`);
}

function getProgress(boxOrders: Message[]): Array<number> {
  let progress = [0, 0, 0, 0, 0, 0];
  if (boxOrders.length == 0) return [0, 0, 0, 0, 1, 0];

  boxOrders.forEach((boxOrder) => {
    progress[orderProgress(boxOrder)] += 1.0 / boxOrders.length;
  });
  return progress;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(UmanaHeadline, { h: "h1" }, {
        default: _withCtx(() => [
          _createTextVNode("Auslieferung")
        ]),
        _: 1
      }),
      _createVNode(IconButton, {
        icon: "scan-barcode",
        color: "green",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (scannerOn.value = !scannerOn.value))
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFolders(), (folderData) => {
          return (_openBlock(), _createBlock(UButton, {
            color: folder.value == folderData.id ? 'orange' : 'white',
            onClick: ($event: any) => (folder.value = folderData.id),
            key: folderData.id,
            class: "w-full md:w-auto"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(folderData.name) + " ", 1),
              (folderData.id != 2 && folderData.amount > 0)
                ? (_openBlock(), _createBlock(SmallTag, {
                    key: 0,
                    small: "",
                    color: folderData.color,
                    class: "ml-s"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(folderData.amount), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["color", "onClick"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(UButton, {
          color: isToday.value && !showCalendar.value ? 'orange' : 'white',
          onClick: _cache[1] || (_cache[1] = ($event: any) => {
          showCalendar.value = false;
          selectedDate.value = new Date();
        }),
          class: "w-full md:w-auto"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Heute ")
          ]),
          _: 1
        }, 8, ["color"]),
        _createVNode(UButton, {
          color: showCalendar.value || (!isToday.value && selectedDate.value) ? 'orange' : 'white',
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showCalendar.value = true)),
          class: "w-full md:w-auto"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(!isToday.value && selectedDate.value
            ? _unref(localeDateStringFromDate)(selectedDate.value)
            : "Datum wählen"), 1)
          ]),
          _: 1
        }, 8, ["color"]),
        _createVNode(UButton, {
          color: !showCalendar.value && !selectedDate.value ? 'orange' : 'white',
          onClick: _cache[3] || (_cache[3] = ($event: any) => {
          showCalendar.value = false;
          selectedDate.value = undefined;
        }),
          class: "w-full md:w-auto"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Alle ")
          ]),
          _: 1
        }, 8, ["color"])
      ])
    ]),
    (scannerOn.value)
      ? (_openBlock(), _createBlock(OrdersScanner, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (scannerOn.value = false))
        }))
      : _createCommentVNode("", true),
    (showCalendar.value)
      ? (_openBlock(), _createBlock(OrderCalendar, {
          key: 1,
          onSelectDate: selectDate
        }))
      : _createCommentVNode("", true),
    (!showCalendar.value && Object.keys(groupedBoxesBySenderGroupId.value).length == 0)
      ? (_openBlock(), _createBlock(EmptyContainer, { key: 2 }, {
          default: _withCtx(() => [
            _createTextVNode(" Keine Kisten vorhanden ")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (!showCalendar.value)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(groupedBoxesBySenderGroupId.value, (boxes, cpgId) => {
            return (_openBlock(), _createBlock(RoundedCard, {
              key: cpgId,
              class: "overflow-scroll mt-xs md:overflow-visible"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(ProfileCircle, {
                    "care-provider-group": _unref(cpgWithId)(cpgId)
                  }, null, 8, ["care-provider-group"]),
                  _createVNode(UmanaHeadline, {
                    h: "h2",
                    class: "mb-m mt-s justify-between"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(cpgWithId)(cpgId)?.group_name ?? "???"), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("table", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(boxes, (box) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: box.id,
                      class: _normalizeClass(["w-full whitespace-nowrap", {
                'bg-red-100': _unref(isBoxOverdue)(box) && folder.value < 2,
              }]),
                      onClick: ($event: any) => (open(box))
                    }, [
                      _createElementVNode("td", null, [
                        _createVNode(ToolTip, { position: "right" }, {
                          content: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(box.orders, (order) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: order.id,
                                class: "flex justify-start items-center my-xs"
                              }, [
                                _createVNode(ProgressDot, {
                                  class: "mr-xs",
                                  progress: orderProgress(order)
                                }, null, 8, ["progress"]),
                                _createElementVNode("div", null, [
                                  _createTextVNode(_toDisplayString(order.medication_order?.amount ?? "?") + "x " + _toDisplayString(order.medication_order?.name ?? "unb.") + " ", 1),
                                  _hoisted_8,
                                  _createElementVNode("i", null, _toDisplayString(_unref(patientString)(
                            order.medication_order?.patient_id ?? -1
                          )), 1)
                                ])
                              ]))
                            }), 128)),
                            (box.orders.length == 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                  _createVNode(ProgressDot, {
                                    progress: 3,
                                    class: "flex-0 mr-xs line-clamp-1"
                                  }),
                                  _hoisted_10
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(CircularProgress, {
                              progress: 
                      getProgress(
                        box.orders.filter(
                          (order) => !order.medication_order?.deleted
                        )
                      )
                    ,
                              class: "mr-xs"
                            }, null, 8, ["progress"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("td", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, "Kiste #" + _toDisplayString(box.id), 1),
                          _createElementVNode("div", _hoisted_14, _toDisplayString(box.medication_box?.name ?? "unbenannte Kiste"), 1),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(box.medication_box?.address1) + _toDisplayString(box.medication_box?.address2) + ", " + _toDisplayString(box.medication_box?.zip) + " " + _toDisplayString(box.medication_box?.city), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_16, [
                        _hoisted_17,
                        _createVNode(SmallTag, {
                          color: "purple",
                          small: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(box.fridge.length), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("td", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(SmallTag, {
                          color: "pink",
                          small: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(box.safe.length), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("td", _hoisted_20, [
                        _hoisted_21,
                        _createVNode(ChangeTag, {
                          type: "box",
                          class: "line-clamp-1",
                          property: "status",
                          boxes: [box],
                          value: box.medication_box?.status ?? 0
                        }, null, 8, ["boxes", "value"])
                      ])
                    ], 10, _hoisted_7))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})